module.exports = __webpack_public_path__ + "img/idx-game-hot.5a051c1.webp";